import { render, staticRenderFns } from "./website-form.vue?vue&type=template&id=4f0a52d4&"
import script from "./website-form.vue?vue&type=script&lang=js&"
export * from "./website-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports